export const FETCH_WORKLIST = "[RECEPTIONIST] FETCH_WORKLIST";
export const FETCH_WORKLIST_START = "[RECEPTIONIST] FETCH_WORKLIST_START";
export const FETCH_WORKLIST_SUCCESS = "[RECEPTIONIST] FETCH_WORKLIST_SUCCESS";
export const FETCH_WORKLIST_ERROR = "[RECEPTIONIST] FETCH_WORKLIST_ERROR";
export const SET_WORKLIST_PAGINATION = "SET_WORKLIST_PAGINATION";

export const UPDATE_WORKLIST_EXAMINATION_STATE = "[RECEPTIONIST] UPDATE_WORKLIST_EXAMINATION_STATE";
export const UPDATE_WORKLIST_EXAMINATION_STATE_START = "[RECEPTIONIST] UPDATE_WORKLIST_EXAMINATION_STATE_START";
export const UPDATE_WORKLIST_EXAMINATION_STATE_SUCCESS = "[RECEPTIONIST] UPDATE_WORKLIST_EXAMINATION_STATE_SUCCESS";
export const UPDATE_WORKLIST_EXAMINATION_STATE_ERROR = "[RECEPTIONIST] UPDATE_WORKLIST_EXAMINATION_STATE_ERROR";

export const UNDO_WORKLIST_VISIT = "[RECEPTIONIST] UNDO_WORKLIST_VISIT";
export const UNDO_WORKLIST_VISIT_START = "[RECEPTIONIST] UNDO_WORKLIST_VISIT_START";
export const UNDO_WORKLIST_VISIT_SUCCESS = "[RECEPTIONIST] UNDO_WORKLIST_VISIT_SUCCESS";
export const UNDO_WORKLIST_VISIT_ERROR = "[RECEPTIONIST] UNDO_WORKLIST_VISIT_ERROR";

export const SET_WORKLIST_CONTEXT = "SET_WORKLIST_CONTEXT";
export const CLEAR_WORKLIST_CONTEXT = "CLEAR_WORKLIST_CONTEXT";


export const fetchWorklist = (payload) => {
    return {
        type: FETCH_WORKLIST,
        payload
    }
}

export const updateExaminationState = (worklist) => {
    return {
        type: UPDATE_WORKLIST_EXAMINATION_STATE,
        payload: { worklist }
    }
}

export const undoWorklistVisit = (visitNo) => {
    return {
        type: UNDO_WORKLIST_VISIT,
        payload: visitNo
    }
}


export const setWorklistContext = (payload) => ({
  type: SET_WORKLIST_CONTEXT,
  payload,
});


export const clearWorklistContext = () => ({
  type: CLEAR_WORKLIST_CONTEXT,
});